"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Sections = require("sections");
var Snippets = require("snippets");
var FaqPageTemplate = /** @class */ (function (_super) {
    __extends(FaqPageTemplate, _super);
    function FaqPageTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.buildAccordion = function (section, index) {
            var counter = _this.state.faq.blocks.length;
            var faqSetting = section.settings;
            var num = index + 1;
            return (React.createElement("div", { className: (num == counter ? "border-transparent " : "border-blue-grey ") + "md:border-b md:pb-1-4 transition-fast" },
                React.createElement("div", { onClick: function () { return _this.toggleOpen(index); } },
                    React.createElement(Snippets.Heading, { size: "", tag: "h4", className: "md:text-xmd px-1-6 md:px-0 text-base md:border-none " + (_this.state.active == index ? "border-border" : "border-transparent") + " border-b font-semibold items-center tracking-none relative flex leading-none cursor-pointer md:pt-4 pt-2 pb-1-2 md:pb-2" },
                        React.createElement("span", { className: "flex-grow" }, faqSetting.title),
                        React.createElement("span", { className: "w-1 h-1" },
                            React.createElement(Snippets.Svg, { name: "" + (_this.state.active == index ? "minus" : "plus"), size: 14, className: "float-right " })))),
                React.createElement("div", { className: "transition-fast md:px-0 px-1-6 " + (_this.state.active == index ? "max-h-1000 " : "max-h-0 overflow-hidden ") },
                    React.createElement("div", { className: " md:pt-0 pt-1-6" },
                        React.createElement("div", { className: "w-full" },
                            React.createElement("div", { className: "w-full " },
                                React.createElement("div", { id: "faqPage", className: "leading-normal inner-padding text-grey-dark", dangerouslySetInnerHTML: { __html: faqSetting.content } }),
                                _this.props.data.page.title.toLowerCase().includes("gift") && faqSetting.title.toLowerCase().includes("balance") && (React.createElement(Snippets.GiftCardBalance, __assign({}, _this.props, { className: "w-1/2 my-0-6" })))))))));
        };
        _this.state = {
            page: _this.props.data.page,
            faq: _this.props.data.section.faq,
            active: 0
        };
        return _this;
    }
    FaqPageTemplate.prototype.render = function () {
        var _this = this;
        var faq = this.state.faq;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("section", { className: "" },
                React.createElement(Snippets.Container, { width: "full", className: "" },
                    React.createElement("div", { className: "relative md:max-h-24 overflow-hidden " + (faq && faq.settings.contentColour ? "text-" + faq.settings.contentColour : "text-black") },
                        faq && faq.settings.desktopBanner ? (React.createElement("div", { className: "relative md:h-24 h-14" },
                            React.createElement(Snippets.Image, { alt: "faqDesktopBanner", className: "bg-cover bg-center absolute pin hidden md:block", src: faq.settings.desktopBanner }),
                            React.createElement(Snippets.Image, { alt: "faqMobileBanner", className: "block md:hidden", src: faq.settings.mobileBanner ? faq.settings.mobileBanner : faq.settings.desktopBanner }))) : (React.createElement("div", { className: "content-placeholder w-full md:h-24 h-14" })),
                        React.createElement("div", { className: "max-w-xl mx-auto flex items-center absolute pin z-10 mlg:px-11 " + (faq && faq.settings.contentColour ? "text-" + faq.settings.contentColour : "text-black") },
                            React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "font-extrabold lg:px-11 px-4 md:text-48 text-xmd" }, this.props.data.page.title ? this.props.data.page.title : "Contact Us")))),
                React.createElement(Snippets.Container, { width: "xl", className: "mx-auto" },
                    React.createElement("div", { className: "pt-1 mlg:px-11 px-0" },
                        React.createElement(Snippets.FaqNavigation, __assign({ active: this.props.data.page.url }, this.props)))),
                React.createElement("div", { className: "bg-fleece md:pb-9-6 pb-6-4" },
                    React.createElement(Snippets.Container, { width: "xl", className: "mx-auto pt-4-8 mlg:px-11 px-1-6" },
                        React.createElement("div", { className: "md:px-11 w-full" },
                            React.createElement(Snippets.Heading, { size: "h2", tag: "h2", className: "font-extrabold mb-1-2 md:text-36 text-xmd text-navy-dark" }, this.props.data.page.title),
                            React.createElement("div", { className: "bg-arctic rounded-md md:px-4 shadow-md" },
                                React.createElement("div", null,
                                    React.createElement("ul", { className: "list-reset w-full" }, faq && faq.blocks && faq.blocks.map(function (section, index) { return _this.buildAccordion(section, index); }))))))),
                React.createElement(Sections.USP, __assign({}, this.props, { section: this.props.data.section.usp })),
                React.createElement(Sections.CTA, __assign({}, this.props, { section: this.props.data.section.cta })))));
    };
    FaqPageTemplate.prototype.toggleOpen = function (nextModal) {
        this.setState({
            active: nextModal == this.state.active ? -1 : nextModal
        });
    };
    return FaqPageTemplate;
}(React.Component));
exports.FaqPageTemplate = FaqPageTemplate;
